import { Component, EventEmitter, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownConfig, DropdownOption } from 'src/app/components/custom-dropdown/custom-dropdown.component';
import {
  FaqBuilder,
  InfoDropdown,
  InfoDropdownContent,
} from 'src/app/components/faq/faq.component';
import { FeatureType } from 'src/app/components/featured-plates/featured-plates.component';
import { SidebarFilterConfig } from 'src/app/components/side-bar-filters/side-bar-filters.component';
import {
  StickyConfig,
  StickyLink,
  StickyLinkGroup,
} from 'src/app/components/sticky-tabs/sticky-tabs.component';
import { CompareFilters } from 'src/app/components/tp-sellers/tp-sellers.component';
import { DVLAVehicleEnquiryResult } from 'src/app/models/dvlaVehicleEnquiryResult';
import { FormattedPlateResponse } from 'src/app/models/formattedPlateResponse';
import { HttpLoadingResp } from 'src/app/models/httpLoadingResp';
import { MarketShare } from 'src/app/models/market-data';
import { PlateDetail } from 'src/app/models/plateDetail';
import { Registration } from 'src/app/models/registration';
import { ImageKeyPair, ImageService } from 'src/app/services/image-service';
import {RegistrationService, RoiMetrics} from 'src/app/services/registration-service';
import {
  SearchReqResponse,
  SearchService,
} from 'src/app/services/search-service';
import { UserService } from 'src/app/services/user-service';
import { environment } from 'src/environments/environment';
import GlobalFaqs from "../../global-faqs";

@Component({
  selector: 'pla-compare-page',
  templateUrl: './compare-page.component.html',
  styleUrls: ['./compare-page.component.scss'],
})
export class ComparePageComponent implements OnInit {
  public filterTrigger: EventEmitter<void> = new EventEmitter<void>();
  public searchTrigger: EventEmitter<void> = new EventEmitter<void>();
  public sortTrigger: EventEmitter<void> = new EventEmitter<void>();
  public sortChange: EventEmitter<string> = new EventEmitter<string>();
  public sortConfig = new DropdownConfig('Sort', 'sort', [
    new DropdownOption('price-ascending', 'Lowest Price'),
    new DropdownOption('price-descending', 'Highest Price'),
  ]);
  public plateStyle: string;
  public favouritePlate: Registration;
  public plateToCompare: string = '';
  public newPage: boolean = true;
  public marketShareData: MarketShare;
  public cards: any[] = [
    {
      number: 'https://cdn.platex.co.uk/pages/compare/point_01.png',
      image:
        'https://cdn.platex.co.uk/pages/compare/_platex_compare_imac.png?t=123',
      title: 'ENTER THE REGISTRATION',
      body: `To compare prices for a private plate you've already chosen, just enter the exact registration number take care to correctly enter the letters 'O' and 'I' and the numbers '0' and '1'.`,
    },
    {
      number: 'https://cdn.platex.co.uk/pages/compare/point_02.png',
      image: 'https://cdn.platex.co.uk/pages/compare/Compare Table.png',
      title: 'SEE HOW MUCH YOU COULD SAVE',
      body: 'Review your comparison results to view prices from over 40 dealers. Find the best deals quickly and discover how much you could save on your plate.',
    },
    {
      number: 'https://cdn.platex.co.uk/pages/compare/point_03.png',
      image: 'https://cdn.platex.co.uk/pages/compare/Compare Filter.png',
      title: 'TAILOR YOUR RESULTS ',
      body: 'You can filter dealer prices to include  acrylic plates or managed transfer service. Prices of options vary greatly so filter to find the best overall deal.',
    },
    {
      number: 'https://cdn.platex.co.uk/pages/compare/point_04.png',
      image: 'https://cdn.platex.co.uk/pages/compare/compare_mac_vert.png',
      title: 'PURCHASE DIRECTLY FROM THE DEALER',
      body: 'Once you\'ve found your ideal plate, click through to the dealer\'s site to complete your purchase. Choose any additional features, arrange payment, and finish the transaction all in one place.',
    },
  ];

  public stickyLinkConfig: StickyConfig = new StickyConfig(
    [
      new StickyLinkGroup([
        new StickyLink('Compare Deals', 'compare-deals', true),
        // new StickyLink(
        //   'Alternative Registrations',
        //   'alternative-registrations',
        //   false
        // ),
        new StickyLink('History', 'history', false),
        // new StickyLink('Market Insights', 'market-insight', false),
        new StickyLink('Q&As', 'faq', false),
      ]),
    ],
    new EventEmitter<void>()
  );
  public rsFeatured = new FeatureType('Recently Sold', 'recently-sold');
  public raFeatured = new FeatureType('Recently Added', 'recently-added');
  public setComparedFilters: SidebarFilterConfig<CompareFilters>;
  public compareFilters = new EventEmitter<
    SidebarFilterConfig<CompareFilters>
  >();

  public registrationLoaded: boolean = false;
  public registration: string;
  public validRegistration: boolean = false;
  public selectedImage: ImageKeyPair = undefined;

  public faq: InfoDropdown[] = GlobalFaqs.GetFaqsByKey('Compare');

  public detail: {
    min: number;
    max: number;
    totalResultCount: number;
    lastUpdate: Date;
    plateDetail: PlateDetail;
    loaded: boolean;
  } = {
      min: 0,
      max: 0,
      totalResultCount: 0,
      lastUpdate: new Date(),
      plateDetail: undefined,
      loaded: false,
    };
  public registeredVehicleInfo: HttpLoadingResp<DVLAVehicleEnquiryResult> =
    new HttpLoadingResp();
  public isRegisteredToVehicle: boolean = false;

  public altResultChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();
  public altSearching: boolean = true;
  public altSearchResults: SearchReqResponse;

  public visibleChartData: { showingChart: boolean; showingTable: boolean } =
    undefined;
  public roiMetrics: RoiMetrics = null;

  constructor(
    private router: Router,
    private imageService: ImageService,
    private activatedroute: ActivatedRoute,
    private registrationService: RegistrationService,
    private userService: UserService,
    private searchService: SearchService,
    private sanitize: DomSanitizer
  ) {
    // check for input
    var reg = this.activatedroute.snapshot.paramMap.get('registration');
    if (reg == null) return;
    this.registration = reg;
    this.formatInput();
  }

  public marketShareDataUpdate(event: MarketShare): void {
    this.marketShareData = event;
  }

  public chartDataUpdate(event: any): void {
    console.log('chart data', event);
    this.visibleChartData = event;
    if (event.roiMetrics != null) {
      this.roiMetrics = event.roiMetrics;
    }
  }

  public sortChanged(dropdown: DropdownOption): void {
    this.sortChange.emit(dropdown.value);
  }

  public hasCompareHistory(): boolean {
    if (this.userService.getHistory('compare').length > 0) return true;
    return false;
  }

  public EnterSubmit(event: KeyboardEvent): void {
    if (event.code === 'Enter') {
      event.stopImmediatePropagation();
      this.StartCompare();
    }
  }

  public StartCompare(): void {
    this.router.navigate([`/compare/${this.plateToCompare}`]);
  }

  public SetCompareFilters(
    compareFilters: SidebarFilterConfig<CompareFilters>
  ): void {
    this.setComparedFilters = compareFilters;
    setTimeout(() => {
      this.compareFilters.emit(compareFilters);
    }, 20);
  }

  public CompareResultsChange(firstLoad: boolean): void {
    this.registrationService.formatRegistrationFromString(
      this.registration,
      this.detail.min,
      this.detail.min > -1,
      (_r) => {
        this.favouritePlate = _r;
      }
    );
    if (firstLoad) return;
    setTimeout(() => {
      this.stickyLinkConfig.reScroll.emit();
    }, 100);
  }

  public DetailLoaded(): boolean {
    return this.detail && this.detail.loaded;
  }

  public PriceRangeChange(data: { min: number, max: number, totalResultCount: number, }): void {
    this.detail = {
      ...this.detail,
      totalResultCount: data.totalResultCount,
      min: data.min,
      max: data.max,
      loaded: true,
    };
    console.log(this.detail);
    if (data.max <= 0) {
      this.FetchAlternateResults();
    }
  }

  private FetchAlternateResults(): void {
    this.altSearching = true;
    this.searchService.searchRaw(
      this.registration.replace(' ', ''),
      (res: SearchReqResponse) => {
        try {
          console.log('super search complete');
          res.registrations = this.registrationService.formatRegistrations(
            res.registrations
          );
          this.altResultChange.emit(res);
          this.altSearchResults = res;
          this.altSearching = false;
        } catch (ex: any) {
          console.warn(ex);
          this.altSearching = false;
        }
      }
    );
  }

  private formatInput(): void {
    this.registrationLoaded = false;
    this.registrationService
      .FormatRegistration(this.registration)
      .subscribe((formattedResp: FormattedPlateResponse) => {
        if (
          formattedResp.formattedRegistration == null ||
          formattedResp.formattedRegistration == ''
        )
          return;
        this.plateStyle = formattedResp.registrationStyle;
        this.validRegistration = formattedResp.valid;
        this.registration = formattedResp.formattedRegistration;
        this.registrationLoaded = true;
        this.generateQuickImage();
      });
  }

  ngOnInit(): void {
    this.GetDetail();
  }

  private GetDetail(): void {
    if (this.registration == '') return;
    this.registrationService
      .getPlateDetail(this.registration)
      .subscribe((d) => {
        this.detail = { ...this.detail, plateDetail: d };
        this.fetchRegisteredVehicleInfo();
      });
  }

  private fetchRegisteredVehicleInfo(): void {
    if (!this.registration || this.registration == '' || this.registration == null) return;
    this.registrationService
      .getVehicleInfo(this.registration.replace(' ', ''))
      .subscribe(
        (_: DVLAVehicleEnquiryResult) => {
          this.registeredVehicleInfo.Update(false, _);
          this.isRegisteredToVehicle = _ != null;
        },
        () => {
          this.registeredVehicleInfo.Update(false, null);
        }
      );
  }

  private generateQuickImage(): void {
    if (this.registration == '') this.registration = 'PLA73X';
    this.imageService.INIT();
    this.imageService.quickBuild(
      this.imageService.getQuickConfig(),
      this.registration,
      (image: ImageKeyPair) => {
        this.selectedImage = image;
      }
    );
  }
}
